import {nativeFontFamilies} from 'shared/front/components/Poke/utils/fonts';

// Copy of isNativeFontFamily from shared front/components/Poke/utils/fonts.js,
// which this repo's src/shared pin predates: import it from there once bumped.

const getPrimaryFontFamily = (fontFamily) => {
  if (typeof fontFamily !== 'string') {
    return '';
  }

  const primary = fontFamily.split(',')[0].trim();

  return primary.replace(/^["']|["']$/g, '');
};

export const isNativeFontFamily = (fontFamily) => {
  if (!fontFamily) {
    return true;
  }

  const primary = getPrimaryFontFamily(fontFamily);

  return nativeFontFamilies.some(
    (nativeFont) =>
      nativeFont === primary || nativeFont.startsWith(`${primary},`)
  );
};
